import { queryClient } from "@/queryClient"

export const deleteUser = async (userId: string) => {
  await api.delete(`/users/${userId}`)

  queryClient.invalidateQueries({
    queryKey: [USERS_QUERY_KEY],
  })

  // As list_roles.user_count may have changed
  queryClient.invalidateQueries({
    queryKey: [ROLES_QUERY_KEY],
  })
}
